(function () {
  if (window.AromaPdpPurchaseFeedback) return;
  window.AromaPdpPurchaseFeedback = true;

  var buttonSelector = [
    '.ap-pdp-atc',
    '.ap-cro__atc',
    '.ap-ro__atc',
    '.ap-df__atc',
    '.ap-hd__atc',
    '.ap-incense__atc',
    '.ap-cro__mobile-bar button',
    '.ap-ro__mobile-bar button',
    '.ap-df__mobile-bar button',
    '.ap-hd__mobile-bar > button',
    '.ap-incense__mobile-bar button'
  ].join(',');
  var pending = new Set();
  function remember(button) {
    if (!button.dataset.apPdpOriginalLabel) {
      var label = button.querySelector('.ap-pdp-atc-label');
      button.dataset.apPdpOriginalLabel = label ? label.textContent : 'Add to cart';
    }
    if (!button.dataset.apPdpOriginalAria) {
      button.dataset.apPdpOriginalAria = button.getAttribute('aria-label') || '';
    }
  }

  function reset(button) {
    window.clearTimeout(button.apPdpFeedbackTimer);
    button.removeAttribute('data-ap-pdp-state');
    button.removeAttribute('aria-busy');
    var label = button.querySelector('.ap-pdp-atc-label');
    if (label) label.textContent = button.dataset.apPdpOriginalLabel || 'Add to cart';
    var originalAria = button.dataset.apPdpOriginalAria || '';
    if (originalAria) button.setAttribute('aria-label', originalAria);
    else button.removeAttribute('aria-label');
    pending.delete(button);
  }

  function start(button) {
    remember(button);
    window.clearTimeout(button.apPdpFeedbackTimer);
    var label = button.querySelector('.ap-pdp-atc-label');
    if (label) label.textContent = 'Adding…';
    button.dataset.apPdpState = 'loading';
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-label', 'Adding to cart');
    pending.add(button);
    button.apPdpFeedbackTimer = window.setTimeout(function () { reset(button); }, 6500);
  }

  function succeed() {
    if (!pending.size) return;
    pending.forEach(function (button) {
      window.clearTimeout(button.apPdpFeedbackTimer);
      button.dataset.apPdpState = 'success';
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-label', 'Added to cart');
      button.apPdpFeedbackTimer = window.setTimeout(function () { reset(button); }, 1400);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(buttonSelector);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    start(button);
  }, true);

  document.addEventListener('cart:added', succeed);
  document.addEventListener('cart:refresh', succeed);
  document.addEventListener('ap:pdp:purchase_success', succeed);
}());
